<template>
  <ul
    class="emd-progress-indicator"
    :class="classList"
  >
    <li
      class="emd-progress-indicator__item"
      v-for="(step, index) in stepsData || totalSteps"
      :key="index"
      :class="{ _active: currentStep === index }"
      @click="goToStep(index)"
    >
      <div class="emd-progress-indicator__label">
        {{ step.label }}
      </div>
      <span class="emd-progress-indicator__icon">
        <emerald-icon icon="circle" />
      </span>
    </li>
  </ul>
</template>

<script>
import EmeraldIcon from '../../atoms/emeraldIcon/EmeraldIcon.vue'

export default {
  name: 'EmdProgressIndicator',
  components: {
    EmeraldIcon
  },
  props: {
    totalSteps: {
      type: Number,
      require: true,
      default: null
    },
    stepsData: {
      type: Array,
      require: false,
      default: null
    },
    size: {
      type: String,
      default: null,
      required: false,
      validator: value => {
        return ['small', null].indexOf(value) !== -1
      }
    },
    color: {
      type: String,
      default: 'primary',
      required: false,
      validator: value => {
        return ['primary', 'secondary', 'tertiary'].indexOf(value) !== -1
      }
    },
    interactive: {
      type: Boolean,
      default: false,
      required: false
    },
    currentStep: {
      type: Number,
      require: false,
      default: 1
    }
  },
  computed: {
    classList () {
      var classList = []
      if (this.interactive) {
        classList.push('_interactive')
      }
      if (this.color) {
        classList.push(`_color_${this.color}`)
      }
      if (this.size) {
        classList.push(`_size_${this.size}`)
      }
      return classList
    },
    iconSize () {
      return this.size === 'small' ? 'xs' : 'sm'
    }
  },
  methods: {
    goToStep (step) {
      this.$emit('goToStep', step - 1)
    }
  }
}
</script>
